import { v4 as uuid } from 'uuid';
export class DistributionListService {
    static $inject = ['MessagingHubService'];
    constructor(MessagingHubService) {
        this.MessagingHubService = MessagingHubService;
    }
    async getDistributionListMessage(listIdentity, messageId) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'get',
            uri: `/lists/${encodeURIComponent(listIdentity)}/messages/${messageId}`,
        });
    }
    async getDistributionLists() {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'get',
            uri: '/lists?$take=999999',
        });
    }
    async setDistributionList(listIdentity) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'set',
            type: 'application/vnd.iris.distribution-list+json',
            uri: '/lists',
            resource: {
                identity: listIdentity,
            },
        });
    }
    async setDistributionListRecipient(listIdentity, recipientIdentity) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'set',
            type: 'application/vnd.lime.identity',
            uri: `/lists/${encodeURIComponent(listIdentity)}/recipients`,
            resource: recipientIdentity,
        });
    }
    async getDistributionListRecipient(listIdentity, recipientIdentity) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'get',
            uri: `/lists/${encodeURIComponent(listIdentity)}/recipients?$take=1`,
        });
    }
    async getDistributionListFailedNotifications(listIdentity, messageId) {
        return await this.MessagingHubService.sendCommand({
            id: uuid(),
            to: 'postmaster@broadcast.msging.net',
            method: 'get',
            uri: `/lists/${encodeURIComponent(listIdentity)}/notifications/${messageId}/failed`,
        });
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
DistributionListService.$inject = ['MessagingHubService'];
